var _style, _path, _g, _defs, _defs2, _defs3, _g2, _line, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullBloodCount({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 113.4 113.4",
    style: {
      enableBackground: "new 0 0 113.4 113.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F3A28A;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{clip-path:url(#SVGID_00000169553192174061519320000003201520235182276030_);}\n\t.st3{clip-path:url(#SVGID_00000019680542573019750960000011390279420446116747_);fill:#E6393D;}\n\t.st4{fill:#E6393D;}\n\t.st5{fill:none;stroke:#FFFFFF;stroke-width:0.5914;stroke-linecap:round;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.7,109.4c29.4,0,53.2-23.6,53.2-52.7S86.1,4,56.7,4S3.6,27.6,3.6,56.7S27.4,109.4,56.7,109.4"
  })), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.8,36.5c-0.2,0.3-0.3,0.4-0.4,0.5c-5.7,8.7-11.2,17.3-16.8,26c-1.7,2.7-2.7,5.7-2.9,8.9 c-1.1,12.8,9.8,23.3,22.5,21.8c14.7-1.7,22.6-18.5,14.4-31c-1.9-3-3.9-6.1-5.8-9.1C64.2,48,60.5,42.3,56.8,36.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.8,36.5c3.7,5.8,7.4,11.4,11.1,17.1c1.9,3,3.9,6.1,5.8,9.1c8.1,12.4,0.3,29.2-14.4,31 c-12.8,1.6-23.6-9-22.6-21.7c0.3-3.2,1.2-6.2,2.9-8.9c5.7-8.7,11.2-17.3,16.8-26C56.4,36.9,56.6,36.8,56.8,36.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M56.8,36.5c-0.2,0.3-0.3,0.4-0.4,0.5c-5.7,8.7-11.2,17.3-16.8,26c-1.7,2.7-2.7,5.7-2.9,8.9 c-1.1,12.8,9.8,23.3,22.5,21.8c14.7-1.7,22.6-18.5,14.4-31c-1.9-3-3.9-6.1-5.8-9.1C64.2,48,60.5,42.3,56.8,36.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000112598337395066357570000005276344115072112782_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000041291967996547381640000007776105537581861504_",
    d: "M56.8,36.5c-0.2,0.3-0.3,0.4-0.4,0.5 c-5.7,8.7-11.2,17.3-16.8,26c-1.7,2.7-2.7,5.7-2.9,8.9c-1.1,12.8,9.8,23.3,22.5,21.8c14.7-1.7,22.6-18.5,14.4-31 c-1.9-3-3.9-6.1-5.8-9.1C64.2,48,60.5,42.3,56.8,36.5z"
  }))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000150088127120329698390000017372079851145155261_",
    d: "M56.8,36.5c3.7,5.8,7.4,11.4,11.1,17.1 c1.9,3,3.9,6.1,5.8,9.1c8.1,12.4,0.3,29.2-14.4,31c-12.8,1.6-23.6-9-22.6-21.7c0.3-3.2,1.2-6.2,2.9-8.9 c5.7-8.7,11.2-17.3,16.8-26C56.4,36.9,56.6,36.8,56.8,36.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000047777201596856575360000014125486174771256238_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000041291967996547381640000007776105537581861504_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000128455535631869214810000004095281504513982082_",
    style: {
      clipPath: "url(#SVGID_00000047777201596856575360000014125486174771256238_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000150088127120329698390000017372079851145155261_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 28.7,
    y: 46.2,
    style: {
      clipPath: "url(#SVGID_00000128455535631869214810000004095281504513982082_)",
      fill: "#E6393D"
    },
    width: 58.8,
    height: 51.9
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M56.8,19.4C56.8,19.5,56.7,19.5,56.8,19.4c-1.4,2.1-2.7,4.1-3.9,6.1c-0.4,0.6-0.6,1.3-0.7,2 c-0.3,3,2.3,5.3,5.2,5c3.4-0.4,5.2-4.3,3.3-7.1c-0.4-0.7-0.9-1.4-1.3-2.1C58.4,22.1,57.7,20.8,56.8,19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M56.8,19.4c0.9,1.3,1.7,2.6,2.5,3.9c0.4,0.7,0.9,1.4,1.3,2.1c1.8,2.9,0.1,6.7-3.3,7.1c-3,0.3-5.4-2.1-5.2-5 c0.1-0.7,0.3-1.4,0.7-2c1.3-2,2.6-4,3.8-6C56.7,19.5,56.7,19.4,56.8,19.4z"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 50.4,
    y1: 56.8,
    x2: 63.1,
    y2: 56.8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 50.4,
    y1: 67.6,
    x2: 63.1,
    y2: 67.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 50.4,
    y1: 78.3,
    x2: 63.1,
    y2: 78.3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 50.4,
    y1: 89,
    x2: 63.1,
    y2: 89
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullBloodCount);
export default __webpack_public_path__ + "static/media/Full_Blood_Count.9bb7cfec3f2a7e13e7c9048bed9bdeb0.svg";
export { ForwardRef as ReactComponent };